/* eslint no-dupe-keys: 0 */
import React from 'react';
import { ListView } from 'antd-mobile';

// import { FacebookProvider, CommentsCount } from 'react-facebook';

import {
  Link
} from 'react-router-dom';

import { Grid } from 'antd-mobile';

import AppHeader from './../AppHeader';

import axios from 'axios';
var moment = require('moment');

let NUM_ROWS = 20;
let LIMIT_ROWS = 20;
let TOTAL_INDEX = 0;
//let MAX_LENGTH = 90;
let MAX_LENGTH = 90;

function genData(pIndex = 0) {
  const dataBlob = {};
  for (let i = 0; i < NUM_ROWS; i++) {
    const ii = (pIndex * NUM_ROWS) + i;
    dataBlob[`${ii}`] = `row - ${ii}`;
  }
  return dataBlob;
}

class TransactionStatus extends React.Component {
  constructor(props) {
    super(props);

    window.BPdata.footerMenu = "home";

    var dataSource = new ListView.DataSource({
      rowHasChanged: (r1, r2) => r1 !== r2
    });

    this.data = [];
    this.state = {
      betlist : 'top_up',
      dataSource: dataSource.cloneWithRows(this.data),
      isLoading: true,
      advertise: []

    };

    this.pageIndex = 1;
    TOTAL_INDEX = 0;
    NUM_ROWS = 20;
    if(this.props.perPage) {
      NUM_ROWS = this.props.perPage;
      TOTAL_INDEX = this.props.pageIndexTotal;
      //console.log(TOTAL_INDEX)
      this.state.isLoading = true;

    }

    this.changeSubMenu      = this.changeSubMenu.bind(this);

  }

  componentDidMount() {


    // if(localStorage.getItem('home_advertise')) {

    //   if(JSON.parse(localStorage.getItem("home_advertise")) != null) {
    //     let home_advertise = JSON.parse(localStorage.getItem("home_advertise"));
    //     this.setState({advertise: home_advertise})
    //   }
    // }

    // if(JSON.parse(localStorage.getItem("videoSlides")) != null) {
    //   let video_slides = JSON.parse(localStorage.getItem("videoSlides"));
    //   this.setState({
    //     dataSource: this.state.dataSource.cloneWithRows(video_slides.reverse()),
    //     isLoading: true,
    //   });
    // }

    // if(localStorage.getItem('homeData')) {
    //   if(JSON.parse(localStorage.getItem("homeData")) != null) {
    //     let home_data = JSON.parse(localStorage.getItem("homeData"));
    //     this.setState({homeData: home_data})
    //     this.setState({
    //       dataSource: this.state.dataSource.cloneWithRows(home_data.dataSource),
    //       isLoading: false,
    //       advertise: home_data.advertise
    //     });
    //   }
    // }
    //TOTAL_INDEX = 20;
    // you can scroll to the specified position
    // setTimeout(() => this.lv.scrollTo(0, 120), 800);

    setTimeout(() => this.lv.scrollTo(0, 0), 800);



    // simulate initial Ajax
    setTimeout(() => {
      this.fetchData();
    }, 600);

    // window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    clearInterval(this.state)
  }


  changeSubMenu(step) {
      // if(step === 'betlist') {
        this.setState({ betlist : step});

        this.fetchData();
          // if(this.state.betlist) {
          //     this.setState({ betlist : step});
          // } else {
          //     this.setState({ betlist : step});
          // }
      // }

  }

  fetchData() {



        let url = window.BPdata.apiUrl+'/cms/transaction/last?transfer_type=0&provider_id='+window.BPdata.provider_id;
        // let data = this.state.data;
        axios({
            method: 'post',
            url: url,
            data: { token : localStorage.getItem(window.BPdata.time) },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "X-Trident-Token" : window.BPdata.token,
                "BP-Agent"         : window.BPdata.rand_compound,
                "BP-Time"         : localStorage.getItem(window.BPdata.time)
                // "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(resp => {
          // console.log(this.data.concat(resp.data));
          this.bet_list = resp.data.deposit;
          this.result_list = resp.data.withdraw;

          if(this.state.betlist == "top_up") {

            this.data = resp.data.deposit;

          } else {

            this.data = resp.data.withdraw;

          }



          // console.log("-----------------");

            this.setState({
              dataSource: this.state.dataSource.cloneWithRows(this.data.reverse()),
              isLoading: false
            });

            // localStorage.setItem("home_advertise", JSON.stringify(resp.data.advertise) )
            // localStorage.setItem("homeData", JSON.stringify({
            //   dataSource: this.data.reverse(),
            //   isLoading: false,
            //   advertise: resp.data.advertise
            // }) )

            // this.data = { ...this.data, ...genData(++this.pageIndex) };
            // console.log(this.data)
            NUM_ROWS = Number(NUM_ROWS) + Number(LIMIT_ROWS);

            //console.log(this.state.advertise)

        })
        .catch(function(error) {
          //console.log(error);
        });

  }


  onEndReached = (event) => {
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading && !this.state.hasMore) {

      return;
    }
    // console.log('reach end', event);
    //this.setState({ isLoading: true });
    if(TOTAL_INDEX !== 0) {
      if(this.pageIndex+1 >= TOTAL_INDEX) {
        this.setState({
          isLoading: false,
        });
      } else {
        this.setState({ isLoading: true });
      }
    } else {
      this.setState({ isLoading: false });
    }

    setTimeout(() => {
      //console.log(this.pageIndex)
      if(TOTAL_INDEX !== 0) {

        if(this.pageIndex+1 >= TOTAL_INDEX) {
          return ;
        }

        //this.data = { ...this.data, ...genData(++this.pageIndex) };

        this.fetchData();
        // this.setState({
        //   // dataSource: this.state.dataSource.cloneWithRows(this.rData),
        //   isLoading: false,
        // });
      } else {
        this.data = { ...this.data, ...genData(++this.pageIndex) };
        this.fetchData();
        // this.setState({
        //   dataSource: this.state.dataSource.cloneWithRows(this.rData),
        //   isLoading: false,
        // });
      }

    }, 1000);
  }

  render() {
    const separator = (sectionID, rowID) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 8,
          borderTop: '1px solid #ECECED',
          borderBottom: '1px solid #ECECED',
        }}
      />
    );
    let index = this.data.length - 1;
    let ui;
    let adcount = 0;
    const row = (rowData, sectionID, rowID) => {
      if (index < 0) {
        index = this.data.length - 1;
      }
      const obj = this.data[index--];



      if (this.state.betlist == "top_up") {
          ui =  <div className="adm-card row grid-100 bg-noise mb-10">

                      <div className="adm-card-body grid-90">
                              <div className="grid-10 left pl-20">
                                    <img src="/img/_women_profile.png" height="30px" />
                              </div>
                              <div className="grid-40 left">
                                      {obj.transaction_date}<br />
                                      {(obj.transfer_type == 1) ? window.lang.form.top_up : ( (obj.transfer_type == 2) ?  window.lang.form.withdrawal  : window.lang.form.transfer  ) }
                              </div>
                              <div className="grid-40 left color-theme-gold text-right">
                                  { obj.amount } MMK >


                              </div>

                      </div>
                      <div className="adm-card-body1 row">

                          <div className="grid-90  pl-20 pt-4 pb-2">
                            <hr style={{ "borderBottom": "1px solid #FFFFFF" , "opacity": "0.25" }} />
                          </div>
                      </div>

                      <div className="adm-card-body grid-90">
                            <div className="grid-30 left left pl-20">
                                  { obj.banktype.name } သို့<br />
                                  { obj.bankaccount.holdername }
                            </div>
                            <div className="grid-60 left color-theme-gold text-right">
                            လုပ်ငန်းစဉ်နံပါတ် - { obj.bank_transaction_id } <br />
                              { obj.bankaccount.cardnum }

                            </div>
                              <div className="grid-40 left pl-20">
                                  <br />
                                  {(obj.approve_status == 1 || obj.approve_status == 0) ? "လုပ်ဆောင်နေပါသည်....." : "" }
                                  {(obj.approve_status == 2) ? ((obj.transfer_type == 1) ? <span className="color-theme-gold">ငွေဖြည့်သွင်းမှု အောင်မြင်ပါသည်။</span> : <span className="color-theme-gold">ငွေဖြည့်သွင်းမှု အောင်မြင်ပါသည်။</span>) : "" }
                                  {(obj.approve_status == 3) ? ((obj.transfer_type == 1) ? "Cancel" : "Cancel") : "" }

                              </div>
                              <div className="grid-40 left">
                                &nbsp;&nbsp;
                              </div>
                              <div className="grid-10 left color-blue">
                                  <br />
                                  {(obj.approve_status == 1 || obj.approve_status == 0) ? <img src="/img/_tloading.png" height="24px" />  : "" }
                                  {(obj.approve_status > 1) ? ((obj.transfer_type == 1) ? <img src="/img/_tsuccess.png" height="24px" /> : <img src="/img/_twithdraw.png" height="24px" />) : "" }

                              </div>

                      </div>
              </div>;
      } else {

          ui =  <div className="adm-card row grid-100 bg-noise mb-10">

                      <div className="adm-card-body grid-90">
                              <div className="grid-10 left pl-20">
                                    <img src="/img/_women_profile.png" height="30px" />
                              </div>
                              <div className="grid-40 left">
                                      {obj.transaction_date}<br />
                                      {(obj.transfer_type == 1) ? window.lang.form.top_up : ( (obj.transfer_type == 2) ?  window.lang.form.withdrawal  : window.lang.form.transfer  ) }
                              </div>
                              <div className="grid-40 left color-theme-gold text-right">
                                  { obj.amount } MMK

                              </div>

                      </div>
                      <div className="adm-card-body row">

                          <div className="grid-90  pl-20 pt-4 pb-4">
                            <hr style={{ "borderBottom": "1px solid #FFFFFF" , "opacity": "0.25" }} />
                          </div>
                      </div>

                      <div className="adm-card-body grid-90">
                              <div className="grid-40 left pl-20">
                                  {(obj.approve_status == 1 || obj.approve_status == 0) ? "လုပ်ဆောင်နေပါသည်....." : "" }
                                  {(obj.approve_status == 2) ? ((obj.transfer_type == 2) ? <span className="color-theme-gold">လူကြီးမင်းဘဏ်အကောင့်သို့ ငွေရောက်ရှိပါပြီ။</span> : <span className="color-theme-gold">လူကြီးမင်းဘဏ်အကောင့်သို့ ငွေရောက်ရှိပါပြီ။</span>) : "" }
                                  {(obj.approve_status == 3) ? ((obj.transfer_type == 2) ? "Cancel" : "Cancel") : "" }

                              </div>
                              <div className="grid-40 left">
                                &nbsp;&nbsp;
                              </div>
                              <div className="grid-10 left color-blue">
                                  {(obj.approve_status == 1 || obj.approve_status == 0) ? <img src="/img/_tloading.png" height="24px" />  : "" }
                                  {(obj.approve_status > 1) ? ((obj.transfer_type == 2) ? <img src="/img/_tsuccess.png" height="24px" /> : <img src="/img/_twithdraw.png" height="24px" />) : "" }

                              </div>

                      </div>
              </div>;

      }

      return (
          ui
      );
    };
    return (
      <div className="page">

        <AppHeader backLink="/more/wallet-store" titleType="3" title={window.lang.title.history} isLoading="false" />
        <div className="page-content">
            <div className="main-content">

                <div className="row">
                  <div className={ (this.state.betlist == "top_up") ? 'grid-50 left text-center tab-holder active' : 'grid-50 left text-center tab-holder'}  onClick={this.changeSubMenu.bind(this,"top_up")}  >
                    {window.lang.title.top_up_history}
                  </div>
                  <div className={ (this.state.betlist == "withdrawal") ? 'grid-50 right text-center tab-holder active' : 'grid-50 right text-center tab-holder'}  onClick={this.changeSubMenu.bind(this,"withdrawal")}>
                    {window.lang.title.withdrawal_history}
                  </div>

                </div>
                <div className="row text-left">


                    <ListView
                      ref={el => this.lv = el}
                      dataSource={this.state.dataSource}
                      renderHeader={() => ""}
                      renderFooter={() => (<div style={{ padding: this.state.isLoading ? 30 : 0 , textAlign: 'center', display: this.state.isLoading ? 'block' : 'none' }}>
                        {this.state.isLoading ? <img src="/img/loading.gif" alt="loading" height="50px"  /> : ''}
                      </div>)}
                      renderRow={row}
                      // renderSeparator={separator}
                      className="am-list"
                      pageSize={10}
                      useBodyScroll
                      // onScroll={() => { console.log('scroll'); }}
                      scrollRenderAheadDistance={500}
                      onEndReached={this.onEndReached}
                      onEndReachedThreshold={10}
                    />
                </div>
          </div>
        </div>
        <footer  className="App-footer">

          <div className="App-footer-inner">
            {/* {window.BPdata.footerMenu} */}
            <Grid data={window.lang.footer}
                columnNum={5}
                renderItem={dataItem => (

                  <Link to={dataItem.url} className="cont-wrap-link hvr-pulse-shrink" style={{width: '100%'}}>
                        { (window.BPdata.footerMenu === dataItem.check )  ? (dataItem.text == "My Profile") ?  <span className="color-white"><img src={dataItem.icon}  height="25px"/><br />{(this.checklogin()) ? dataItem.text : "Login / Register" }</span> : <span className="text-white"><img src={dataItem.icon_off}  height="25px"/><br /><span >{dataItem.text}</span> </span> : <span className="text-white"><img src={dataItem.icon}  height="25px"/><br />{dataItem.text} </span> }

                  </Link>
                )}
              />

          </div>
        </footer>
      </div>
    );
  }
}

export default TransactionStatus;
